module.exports = __webpack_public_path__ + "img/icon-medal.d94cb2d7.svg";